import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { DrtContext } from "../../../context/DrtContext";
import { imageURL } from "../../../constants";

const TopHeader = () => {
  const [togglelang, setToggle] = useState(false);
  const {
    handleSizeDecrease,
    handleSizeIncrease,
    handleSizeOriginal,
    normalTheme,
    blackTheme,
    handlelangChange,
    handlelangChangedefault,
    setExternalLink,
    setSource,
    setExternalLinkPopupShow,
    lang,
  } = useContext(DrtContext);

  // Google Translate Setup
  useEffect(() => {
    const flags = document.getElementsByClassName("flag_link-hi");
    const flagsen = document.getElementsByClassName("flag_link-en");

    Array.prototype.forEach.call(flags, (e) => {
      e.addEventListener("click", () => {
        const lang = e.getAttribute("data-lang");
        const languageSelect = document.querySelector("select.goog-te-combo");
        if (languageSelect) {
          languageSelect.value = lang;
          languageSelect.dispatchEvent(new Event("change"));
        }
      });
    });

    Array.prototype.forEach.call(flagsen, (e) => {
      e.addEventListener("click", () => {
        const lang = e.getAttribute("data-lang");
        const languageSelect = document.querySelector("select.goog-te-combo");
        if (languageSelect) {
          languageSelect.value = lang;
          languageSelect.dispatchEvent(new Event("change"));
        }
      });
    });
  }, []);

  const handleEnClick = () => {
    setToggle(!togglelang);
    handlelangChangedefault();
  };

  const handleHiClick = () => {
    setToggle(!togglelang);
    handlelangChange();
  };

  return (
    <header role="banner" className="top-header">
      <div className="container container-fluid-2">
        <div className="row align-items-center">
          {/* LEFT SIDE QUICK LINKS */}
          <nav
            className="col-12 col-sm-12 col-md-12 col-lg-3 left-nav"
            aria-label="Quick Links"
          >
            <ul>
              <li className="nobdr">
                <a
                  href="https://efiling.drt.gov.in/edrt/help-center"
                   target="_blank"
                  rel="noopener noreferrer"
                >
                  Feedback
                </a>
              </li>
              <li className="nobdr">
                <Link to="/sitemap">Sitemap</Link>
              </li>
              <li className="nobdr">
                <a
                  href="https://efiling.drt.gov.in/edrt/dratcauselist_deskboard.php"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Display Board
                </a>
              </li>
            </ul>
          </nav>

          {/* RIGHT SIDE NAVIGATION */}
          <nav
            className="col-12 col-sm-12 col-md-12 col-lg-9 top-right-nav"
            aria-label="Top Utility Links"
          >
            <ul>
              <li>
                <a
                  className="hide skiptomain"
                  href={`${imageURL}/efiling_notice.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  E-Sewakendra SOP
                </a>
              </li>

              <li>
                <a
                  href="https://efiling.drt.gov.in/edrt/help-center"
                  className="help-desk-top"
                   target="_blank"
                  rel="noopener noreferrer"
                >
                  Help Desk
                </a>
              </li>

              <li>
                <a
                  href="https://efiling.drt.gov.in/edrt/help-center"
                  className="help-desk-top"
                   target="_blank"
                  rel="noopener noreferrer"
                >
                  Help Desk for Female
                </a>
              </li>

              <li>
                <Link to="/screenreader" className="hide">
                  {lang === "en"
                    ? "Screen Reader Access"
                    : "स्क्रीन रीडर एक्सेस"}
                </Link>
              </li>

              <li className="text-size">
                <a href="#" onClick={handleSizeIncrease}>
                  A+
                </a>
                <a href="#" onClick={handleSizeOriginal}>
                  A
                </a>
                <a href="#" onClick={handleSizeDecrease}>
                  A-
                </a>
                <a href="#" className="whitebg p-1" onClick={normalTheme}>
                  A
                </a>
                <a href="#" className="blackbg p-1" onClick={blackTheme}>
                  A
                </a>
              </li>

              <li className="nobdr lang pr-2">
                <a
                  href={`${process.env.REACT_APP_INTERNAL_LOGIN_URL}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-user-lock"></i>&nbsp;Login
                </a>
              </li>

              <li className="border-right-0 p-0">
                <span
                  className="google-translate-wrap"
                  id="google_translate_element"
                ></span>
              </li>

              <li className="lang-custom">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => setToggle(!togglelang)}
                  onKeyDown={(e) =>
                    e.key === "Enter" && setToggle(!togglelang)
                  }
                >
                  Select&nbsp;Language&nbsp;
                  <i className="fas fa-caret-down"></i>
                </span>
                <div
                  className={togglelang ? "flag flag-language" : "flag"}
                  aria-hidden={!togglelang}
                >
                  <span
                    className="flag_link-en en"
                    onClick={handleEnClick}
                    data-lang="en"
                  >
                    English
                  </span>
                  <span
                    className="flag_link-hi hi"
                    onClick={handleHiClick}
                    data-lang="hi"
                  >
                    हिंदी
                  </span>
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default TopHeader;
